var map = {
	"./AGRALE.svg": "2d4b",
	"./BEPOBUS.svg": "562d",
	"./CHEVROLET.svg": "e1f9",
	"./DAF.svg": "eee5",
	"./Desconhecida.svg": "3296",
	"./EFFA-JMC.svg": "a09b",
	"./FIAT.svg": "fc49",
	"./FORD.svg": "a505",
	"./FOTON.svg": "572f",
	"./GMC.svg": "f306",
	"./HYUNDAI.svg": "d668",
	"./IVECO.svg": "d124",
	"./MAN.svg": "7b34",
	"./MARCOPOLO.svg": "e184",
	"./MASCARELLO.svg": "c958",
	"./MERCEDES-BENZ.svg": "5491",
	"./NAVISTAR.svg": "7a79",
	"./NEOBUS.svg": "2481",
	"./SAAB-SCANIA.svg": "63a3",
	"./SCANIA.svg": "609a",
	"./SHACMAN.svg": "ece9",
	"./SINOTRUK.svg": "d56b",
	"./VOLKSWAGEN.svg": "571b",
	"./VOLVO.svg": "0b94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2beb";